import { CSS_BREAKPOINTS } from '@sbercloud/uikit-product-utils';
import styles from "./styles.module.css";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function HeroSlideImage(_ref) {
  var source = _ref.source,
    format = _ref.format,
    layoutType = _ref.layoutType;
  var tablet = source.tablet,
    desktop = source.desktop;
  if (layoutType === 'mobile') {
    return null;
  }
  return /*#__PURE__*/_jsxs("picture", {
    className: styles.imageWrapper,
    "data-image-format": format,
    "data-layout-type": layoutType,
    children: [tablet && /*#__PURE__*/_jsx("source", {
      srcSet: tablet,
      media: CSS_BREAKPOINTS.tablet
    }), /*#__PURE__*/_jsx("source", {
      srcSet: desktop,
      media: CSS_BREAKPOINTS.large
    }), /*#__PURE__*/_jsx("img", {
      src: desktop,
      className: styles.image,
      "data-image-format": format,
      loading: "lazy",
      alt: "main slide"
    })]
  });
}